import Vue from "vue";
import { newLogger } from "../../../utils/util";
import network from "../../../utils/network";
import { update } from "lodash";

let logger = newLogger("TimeslotStore");

const urls = {
  getTimeslotsByCustomerId: `/credit/kyc/timeslot/my-timeslots`,
  updateById: (id) => `/credit/kyc/timeslot/update/${id}`,
  deleteById: (id) => `/credit/kyc/timeslot/${id}`,
  create: `/credit/kyc/timeslot/create-my-timeslot`,
};

/**
 * Timeslot store
 */

const initState = () => {
  return {
    appointments: [],
  };
};

const actions = {
  fetchByCustomerId: async ({ commit }) => {
    try {
      let axios = await network.connection();
      let { data } = await axios.get(urls.getTimeslotsByCustomerId);
      commit("save", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  create: async ({dispatch}, request) => {
    try {
      let axios = await network.connection();
      await axios.post(urls.create, request);
      dispatch("fetchByCustomerId");
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  updateById: async ({dispatch}, {id, request}) => {
    try {
      let axios = await network.connection();
      await axios.put(urls.updateById(id), request);
      dispatch("fetchByCustomerId");
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  deleteById: async ({dispatch}, id) => {
    try {
      let axios = await network.connection();
      await axios.delete(urls.deleteById(id));
      dispatch("fetchByCustomerId");
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  save: (state, data) => {
    Vue.set(state, "appointments", data);
  },
};

const getters = {
  get: (state) => {
    return state.appointments;
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations,
  actions,
  getters,
};
